module.exports = __webpack_public_path__ + "img/turkish-lira-sign.88c82b1d.svg";